<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.job_no ||
                Filter.log_subject ||
                Filter.email_type ||
                Filter.createdByFilter ||
                Filter.log_status ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.job_no ||
                Filter.log_subject ||
                Filter.email_type ||
                Filter.createdByFilter ||
                Filter.log_status ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getEmailLogList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getEmailLogList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Status</label>

                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.log_status"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Email Type</label>

                  <model-list-select
                    :list="StatusTypeList"
                    v-model="Filter.email_type"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Job No Filter"
                    id="job_no"
                    name="job_no"
                    autocomplete="off"
                    v-model="Filter.job_no"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Subject</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Subject Filter"
                    id="log_subject"
                    name="log_subject"
                    autocomplete="off"
                    v-model="Filter.log_subject"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getEmailLogList"
                :fields="emailLogFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>

                <template slot="log_attachment" slot-scope="row1">
                  <b-badge :variant="row1.item.log_status == 0 ? 'warning' : 'success'">{{
                    row1.item.logStatus
                  }}</b-badge>
                  <div v-if="row1.item.log_attachment">
                    <b-button
                      v-for="(item1, index) in row1.item.log_attachment.split(',')"
                      :key="index"
                      style="margin-left: 2px; font-size: 0.675rem"
                      @click="item1 ? PrintValidity_Doc(item1, row1.item.log_job_no) : ''"
                      size="sm"
                      variant="warning"
                      class="mb-1"
                      >{{ item1 ? "PDF" + (parseInt(index) + 1) : "" }}</b-button
                    >
                  </div>
                </template>
                <template slot="log_to_email" slot-scope="row5">
                  <div class="text-left" v-if="row5.item.log_to_email">
                    <div v-if="row5.item.log_to_email">
                      <span
                        v-for="(item1, index) in row5.item.log_to_email.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                </template>
                <template slot="log_cc_email" slot-scope="row5">
                  <div class="text-left" v-if="row5.item.log_cc_email">
                    <div v-if="row5.item.log_cc_email">
                      <span
                        v-for="(item1, index) in row5.item.log_cc_email.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                </template>
                <template slot="log_bcc_email" slot-scope="row5">
                  <div class="text-left" v-if="row5.item.log_bcc_email">
                    <div v-if="row5.item.log_bcc_email">
                      <span
                        v-for="(item1, index) in row5.item.log_bcc_email.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                </template>
                <template slot="SendBy" slot-scope="row3">
                  <span v-if="row3.item.SendBy"
                    >Raised By : {{ row3.item.SendBy }}<br
                  /></span>
                  <span v-if="row3.item.CreatedDate"
                    >Created Date : {{ row3.item.CreatedDate }}<br
                  /></span>
                  <span v-if="row3.item.upDatedBy"
                    >Updated By : {{ row3.item.upDatedBy }}<br
                  /></span>
                  <span v-if="row3.item.UpdatedDate"
                    >Updated Date : {{ row3.item.UpdatedDate }}<br
                  /></span>

                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="ViewEmail(row3.item)"
                    variant="primary"
                    >View EMail</b-button
                  >
                  <b-button
                    v-if="row3.item.log_status == 0"
                    size="sm"
                    class="ml-2"
                    @click="sendEmail(row3.item)"
                    variant="primary"
                    >Send</b-button
                  >
                </template>
              </b-table>
            </div>

            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <!-- Additional Extra Payment Modal Start -->
    <b-modal
      id="modal-email-log"
      ref="modal-email-log"
      :title="Email_log_job_no"
      size="lg"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3 v-if="Email_log_subject">{{ Email_log_subject }}</h3>
      <span v-html="Email_log_body">{{ Email_log_body }}</span>

      <b v-if="Email_log_attachment.length > 0">
        <u><h4>Supporting Documents</h4></u><br />
        <span
          v-for="(item_doc, index_doc) in Email_log_attachment.split(',')"
          :key="index_doc"
        >
          <a
            href="javascript:void(0)"
            @click="PrintValidity_Doc(item_doc, Email_log_job_no)"
            >View Doc - {{ index_doc + 1 }}</a
          ><br />
        </span>
      </b>

      <b-button @click="closeEmailLog" variant="danger" class="pull-right">
        Close</b-button
      >
    </b-modal>
    <!-- Additional Extra Payment Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/log/email-log");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getEmailLogTempList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      Email_log_attachment: "",
      Email_log_subject: "",
      Email_log_job_no: "",
      Email_log_body: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getEmailLogList: [],
      totalData: 0,
      emailLogFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "log_job_no",
          mainkey: "log_job_no",
          label: "Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "log_email_type",
          mainkey: "log_email_type",
          label: "Email Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "log_subject",
          mainkey: "log_subject",
          label: "Subject",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "log_to_email",
          mainkey: "log_to_email",
          label: "To Email",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "log_cc_email",
          mainkey: "log_cc_email",
          label: "CC Email",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "log_bcc_email",
          mainkey: "log_bcc_email",
          label: "BCC EMail",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "log_attachment",
          mainkey: "log_attachment",
          label: "Document",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "SendBy",
          mainkey: "SendBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      StatusList: [
        {
          DVal: "0",
          DText: "Failed",
        },
        {
          DVal: "1",
          DText: "Success",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],
      StatusTypeList: [
        {
          DVal: "Multiple Expense",
          DText: "Multiple Expense",
        },
        {
          DVal: "Additional Task",
          DText: "Additional Task",
        },
        {
          DVal: "",
          DText: "All",
        },
      ],

      Filter: {
        job_no: "",
        log_subject: "",
        email_type: "",
        clientFilter: "",
        createdByFilter: "",
        log_status: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},

  methods: {
    clearFilter() {
      this.Filter = {
        job_no: "",
        log_subject: "",
        email_type: "",
        createdByFilter: "",
        log_status: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    sendEmail(item) {
      let payload = {};
      if (item.log_id > 0) {
        this.isLoading = true;
        payload = {
          itemCode: "sendEmailLog",
          log_id: item.log_id,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getEmailLogTempList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on sendEmailLog Error: ", error);
          });
      }
    },

    ViewEmail(item) {
      this.Email_log_attachment = item.log_attachment;
      this.Email_log_subject = item.log_subject;
      this.Email_log_job_no = item.log_job_no;
      this.Email_log_body = item.log_body;

      this.$refs["modal-email-log"].show();
    },
    closeEmailLog() {
      this.Email_log_attachment = "";
      this.Email_log_subject = "";
      this.Email_log_job_no = "";
      this.Email_log_body = "";
      this.$refs["modal-email-log"].hide();
    },
    PrintValidity_Doc(item, job_no) {
      if (!item || !job_no) return;
      let key =
        "ASSIGNMENT_UPLOADS/" + job_no.replaceAll("/", "_") + "/" + item;
      this.openSignedDocument(key);
    },
    getEmailLogTempList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getEmailLogList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getEmailLogList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getEmailLogList.length > 0) {
                this.totalData = data.totalRows;
                this.getEmailLogList = data.getEmailLogList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getEmailLogList.length > 0) {
                this.totalData = data.totalRows;
                this.getEmailLogList = data.getEmailLogList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getEmailLogList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getEmailLogTempList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getEmailLogTempList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEmailLogTempList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEmailLogTempList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// EmailLogList.vue?6bea325a